module.exports = __webpack_public_path__ + "img/home-admin.d83fef2a.png";